// extracted by mini-css-extract-plugin
export var active = "slideIndicator-module--active--79b87";
export var indicator = "slideIndicator-module--indicator--f500c";
export var lemon = "slideIndicator-module--lemon--42ea9";
export var poppy = "slideIndicator-module--poppy--7f59b";
export var slideIndicator = "slideIndicator-module--slideIndicator--dae0a";